import React from 'react';

import ToolTip from '../common/ToolTip';

class MenuItem extends React.Component {
    render () {
        const { children, Dyn, tip, className, onClick, role, ...props } = this.props;
        let clickProps = {
            onClick: (e) => {
                onClick && onClick(e);
            },
            onKeyPress: (e) => {
                var code = e.which;
                // 13 = Return, 32 = Space
                if ((code === 13) || (code === 32)) {
                    onClick && onClick(e);
                }
            }
        };
        const menuItemProps = {
            tabIndex: 0,
            className: `tde-menu-item ` + (className || ''),
            ...clickProps,
            ...props
        };
        // Only add role if explicitly provided (for accessibility menu pattern)
        if (role) {
            menuItemProps.role = role;
        }
        const menu = (<div {...menuItemProps}>
                        {children}
                    </div>);
        return tip? (
            <ToolTip tip={tip} Dyn={Dyn}>{menu}</ToolTip>
        ): menu;
    }
}

export default MenuItem
